// Texty výberu varianty (`modules/variantPicker.js`).
export default {
  // --- čtení nativního textu Shoptetu ---
  // SK: neověřeno ve fixtures („Veľkosť: M - Skladom >5 ks"), formát volby je jazykově nezávislý
  optionRe: /^([^:]+):\s*(.+?)(?:\s+-\s+(.*))?$/,
  // --- texty ---
  choose: (param) => 'Vyberte ' + param.toLowerCase(),
  soldTitle: 'Momentálne nedostupné',
  soldList: (list) => 'Momentálne nedostupné: ' + list,
  lastPieces: (n) => 'Posledné ' + n + ' ks v tejto veľkosti',
  pieces: (n) => n + '\u00A0ks',
};
